var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#65D8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0118 14.9564H12.7907C12.2901 14.9564 11.875 14.5413 11.875 14.0407C11.875 13.5401 12.2901 13.125 12.7907 13.125H37.2093C37.7099 13.125 38.125 13.5401 38.125 14.0407C38.125 14.5413 37.7099 14.9564 37.2093 14.9564H35.9885V28.8139C35.9885 31.1337 34.7676 32.3546 32.4478 32.3546L25.9158 32.3546V35.4558L30.2867 37.6413C30.7507 37.861 30.9338 38.4104 30.7019 38.8744C30.5431 39.1918 30.2135 39.375 29.8838 39.375C29.7495 39.375 29.603 39.3384 29.4809 39.2773L25.0001 37.043L20.5193 39.2773C20.3972 39.3384 20.2507 39.375 20.1164 39.375C19.7867 39.375 19.4571 39.1918 19.2984 38.8744C19.0664 38.4104 19.2495 37.861 19.7135 37.6413L24.0844 35.4558V32.3546L17.5525 32.3546C15.2327 32.3546 14.0118 31.1337 14.0118 28.8139V14.9564ZM27.2344 25.2855L31.0804 22.0744C31.4711 21.7448 31.5199 21.1709 31.2025 20.7802C30.8728 20.3895 30.299 20.3285 29.9083 20.6581L26.3309 23.6372L25.049 21.5006C24.817 21.1099 24.4385 20.8413 23.999 20.768C23.5716 20.6948 23.1199 20.8168 22.7658 21.1099L18.9199 24.3209C18.5292 24.6506 18.4682 25.2244 18.7978 25.6151C18.981 25.8349 19.2496 25.9448 19.5059 25.9448C19.7135 25.9448 19.9211 25.8837 20.092 25.7372L23.6693 22.7581L24.9513 24.8948C25.1833 25.2855 25.5618 25.5541 26.0013 25.6273C26.4286 25.7006 26.8804 25.5785 27.2344 25.2855Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAvatar);
export default __webpack_public_path__ + "static/media/icon_avatar.f517b3714b0ff65b9c51e5c78d5818e4.svg";
export { ForwardRef as ReactComponent };